import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SedsCheckFormTypeService } from '../../shared/services/seds-check-form-type/seds-check-form-type.service';

import { SedsCheckboxComponent } from './seds-checkbox.component';

@NgModule({
  declarations: [SedsCheckboxComponent],
  imports: [CommonModule, FormsModule, MatCheckboxModule, ReactiveFormsModule],
  exports: [SedsCheckboxComponent],
  providers: [FormGroupDirective, SedsCheckFormTypeService],
})
export class SedsCheckboxModule {}
